<template>

  <!-- KPIs -->
  <!-- <section class="grid grid-cols-1 md:grid-cols-3 gap-8">
    <div
      v-for="kpi in kpis"
      :key="kpi.label"
      class="bg-white p-10 rounded-3xl premium-shadow border border-slate-50
             flex flex-col justify-between min-h-[220px]"
    >
      <div>
        <p class="text-[11px] font-bold uppercase tracking-[0.15em] text-slate-400">
          {{ kpi.label }}
        </p>
        <h2 class="text-6xl font-black tracking-tighter">
          {{ kpi.value }}
          <span v-if="kpi.suffix" class="text-2xl opacity-30">{{ kpi.suffix }}</span>
        </h2>
      </div>

      <div
        v-if="kpi.trend"
        class="flex items-center gap-2 text-emerald-600 bg-emerald-50
               px-3 py-1 rounded-full text-xs font-bold w-fit"
      >
       <i class='bx bx-trending-up text-sm'></i>
        {{ kpi.trend }}
      </div>
    </div>
  </section> -->

  <!-- Discovery CTA -->
  <section
    class="bg-white p-8 rounded-[2rem] premium-shadow border border-slate-50
           flex flex-col md:flex-row md:items-center md:justify-between gap-6"
  >
    <div>
      <p class="text-[11px] font-bold uppercase tracking-[0.15em] text-slate-400">
        Influencer Discovery
      </p>
      <p class="mt-2 text-sm text-slate-700">
        Search creators using verified audience intelligence.
      </p>
      <p class="mt-2 text-xs text-slate-400">
        No estimates. No scraped data. Only verified fan graphs.
      </p>
    </div>

    <button
      @click="gotoinflu()"
      class="bg-primary text-white font-bold px-8 py-4 rounded-xl
             flex items-center gap-2 text-xs uppercase tracking-wider
             hover:opacity-90 transition-all w-fit"
    >
      Explore Influencers
     <i class='bx bx-search text-sm'></i>
    </button>
  </section>

  <!-- Intelligence + Activity -->
  <section class="grid grid-cols-1 lg:grid-cols-12 gap-12">

    <!-- LEFT -->
    <div class="lg:col-span-12 space-y-12">

      <!-- Market Intelligence -->
      <div class="flex items-end justify-between">
        <div>
          <h3 class="text-3xl font-bold">Market Intelligence</h3>
          <p class="text-slate-400">
            Aggregated insights across verified creator audiences.
          </p>
        </div>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-2 gap-8">
        <!-- Category Distribution -->
        <div class="bg-white p-8 rounded-[2rem] premium-shadow border border-slate-50">
          <h4 class="font-bold mb-6">Top Categories</h4>

          <ul class="space-y-4">
            <li
              v-for="c in categories"
              :key="c.name"
              class="flex justify-between items-center"
            >
              <span class="text-sm font-bold text-slate-700">
                {{ c.name }}
              </span>
              <span class="text-xs font-bold text-slate-400">
                {{ c.count }} creators
              </span>
            </li>
          </ul>
        </div>

        <!-- Platform Mix -->
        <div class="bg-white p-8 rounded-[2rem] premium-shadow border border-slate-50">
          <h4 class="font-bold mb-6">Platform Mix</h4>

          <ul class="space-y-4">
            <li
              v-for="p in platforms"
              :key="p.name"
              class="flex justify-between items-center"
            >
              <span class="text-sm font-bold text-slate-700">
                {{ p.name }}
              </span>
              <span class="text-xs font-bold text-slate-400">
                {{ p.percent }}%
              </span>
            </li>
          </ul>
        </div>
      </div>

      <!-- Audience Reach Visual -->
     <div
        class="bg-white rounded-[2.5rem] premium-shadow
              border border-slate-50 p-8"
      >
        <h4 class="font-bold mb-6">Verified Audience Reach Trend</h4>
        <div id="reachChart"></div>
      </div>
    </div>

    <!-- RIGHT -->
    <!-- <div class="lg:col-span-4 space-y-8">

      <h3 class="text-3xl font-bold">Recent Activity</h3>

      <div class="bg-primary text-white p-8 rounded-[2rem] premium-shadow">
        <p class="text-xs uppercase opacity-60">Brand Plan</p>
        <h4 class="text-2xl font-bold mt-2">
          {{ plan.name }}
        </h4>
        <p class="text-xs opacity-60 mt-1">
          Renewal {{ plan.renewal }}
        </p>
      </div>

      <div
        class="bg-white rounded-[2rem] premium-shadow
               border border-slate-50 overflow-hidden"
      >
        <div class="p-8 border-b border-slate-50">
          <h4 class="text-sm font-bold text-slate-900">
            Recently Viewed Influencers
          </h4>
        </div>

        <div class="divide-y divide-slate-50">
          <div
            v-for="i in recent"
            :key="i.id"
            class="px-8 py-5 flex items-center justify-between
                   hover:bg-slate-50/50 transition-colors"
          >
            <div>
              <p class="text-[13px] font-bold text-slate-700">
                {{ i.name }}
              </p>
              <p class="text-[11px] text-slate-400">
                {{ i.platform }} · {{ i.category }}
              </p>
            </div>

            <span class="text-[11px] font-bold text-slate-400">
              {{ i.fans }}
            </span>
          </div>
        </div>

        <div class="p-6 bg-slate-50/50 text-center">
          <button
            class="text-[11px] font-bold text-slate-400
                   hover:text-slate-900 transition-colors
                   uppercase tracking-widest"
          >
            View All
          </button>
        </div>
      </div>

    </div> -->
  </section>

</template>

<script>
import ApexCharts from "apexcharts";
import { loadAgencyDashboardApi } from "../apis/agencyapis1";

export default {
  name: "DashboardScreen3",

  data() {
    return {
      user_id: "",
      kpis: [],
      categories: [],
      platforms: [],
      recent: [],
      plan: {
        name: "",
        renewal: ""
      },

      reachChart: null
    };
  },

  async mounted() {

    try {

      const ldataRaw = sessionStorage.getItem("ldata");

      if (ldataRaw && ldataRaw !== "undefined") {

        const ldata = JSON.parse(ldataRaw);

        if (ldata && ldata.user_id) {
          this.user_id = ldata.user_id;
        }
      }

    } catch (e) {

      console.log("Session parse error", e);
    }

    if (this.user_id) {
      await this.loadDashboard();
    }
  },

  methods: {
    gotoinflu(){
      window.location.href = "/agency/discover";
    },
    async loadDashboard() {

      const res = await loadAgencyDashboardApi(this.user_id);

      if (res && res.status) {

        this.kpis = res.kpis || [];
        this.categories = res.categories || [];
        this.platforms = res.platforms || [];
        this.recent = res.recent || [];

        this.plan = res.plan || {
          name: "No Active Plan",
          renewal: "-"
        };

        // ✅ Render Charts AFTER data
        this.renderReachChart(res);

      } else {

        console.log("Dashboard API failed");

        this.kpis = [];
        this.categories = [];
        this.platforms = [];
        this.recent = [];
        this.plan = {
          name: "No Data",
          renewal: "-"
        };
      }
    },

    renderReachChart(res) {

      if (this.reachChart) {
        this.reachChart.destroy();
      }

      const labels = res.reachLabels ?? [];
      const trend  = res.reachTrend ?? [];

     const options = {
  chart: {
    type: "line",
    height: 260,
    width: "100%",
    toolbar: { show: false }
  },
  stroke: {
    curve: "smooth",
    width: 3
  },
  series: [
    {
      name: "Verified Reach",
      data: trend
    }
  ],
  xaxis: {
    categories: labels
  },
  colors: ["#0f172a"],
  grid: {
    borderColor: "#f1f5f9",
    strokeDashArray: 4,
    padding: { left: 10, right: 10 }
  }
};

      this.reachChart = new ApexCharts(
        document.querySelector("#reachChart"),
        options
      );

      this.reachChart.render();
    }
  }
};

</script>
<style scoped>
#reachChart {
  width: 100%;
  overflow: hidden;
}
</style>
